import Profile from "../../model/profile";
import * as actionType from "../actions/actionTypes";

export const profileReducer = (state: Profile | null = null, action: any) => {
  switch (action.type) {
    case actionType.SET_PROFILE: {
      if (action.payload !== undefined) {
        state = action.payload.profile;
      }
      return state;
    }
    default:
      return state;
  }
};
